<template>
  <div class="jpcolbanner flex">
    <div class="flswip">
      <el-carousel
        trigger="click"
        arrow="never"
        :interval="5000"
        height="350px"
      >
        <el-carousel-item
          v-for="(item, index) in list"
          :key="index"
          @click.native="tojumpdet(item)"
        >
          <div class="fd">
            <div class="bt ellipsis">{{ item.title }}</div>
            <div class="nr">
              {{ item.content | toEllipsisFilter(100) }}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="tmfrom">
      <div class="from between wrap">
        <div class="inp flex_start">
          <div>关键词：</div>
          <div class="text"><input type="text" v-model="seaobj.title" /></div>
        </div>
        <div class="inp flex_start">
          <div>发文字号：</div>
          <div class="text">
            <input type="text" v-model="seaobj.issue_number" />
          </div>
        </div>
        <div class="inp flex_start">
          <div>颁布单位：</div>
          <div class="text">
            <input type="text" v-model="seaobj.issue_unit" />
          </div>
        </div>
        <div class="inp flex_start">
          <div>效力级别：</div>
          <el-select
            :popper-append-to-body="false"
            v-model="seaobj.effect_level"
            placeholder="请选择"
            class="sele1"
          >
            <el-option
              v-for="item in xllist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="inp flex_start">
          <div>时效性：</div>
          <el-select
            :popper-append-to-body="false"
            v-model="seaobj.timeliness"
            placeholder="请选择"
            class="sele1"
          >
            <el-option
              v-for="item in sxlist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="inp2 between">
          <el-date-picker
            class="itm"
            v-model="seaobj.start_date"
            type="date"
            :clearable="false"
            value-format="timestamp"
            placeholder="起始日期"
          >
          </el-date-picker>
          <el-date-picker
            class="itm"
            v-model="seaobj.end_date"
            type="date"
            value-format="timestamp"
            :clearable="false"
            placeholder="结束时间"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="search" @click="subsearch">搜索</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list"],
  data: () => ({
    xllist: [
      { value: "宪法", label: "宪法" },
      { value: "法律", label: "法律" },
      { value: "行政法规", label: "行政法规" },
      { value: "地方性法规", label: "地方性法规" },
      { value: "自治条例和单行条例", label: "自治条例和单行条例" },
      { value: "部门规章", label: "部门规章" },
      { value: "地方规章", label: "地方规章" },
    ],
    sxlist: [
      { value: "现行有效", label: "现行有效" },
      { value: "现已失效", label: "现已失效" },
      { value: "尚未生效", label: "尚未生效" },
      { value: "已修订", label: "已修订" },
    ],
    seaobj: {},
  }),
  methods: {
    tojumpdet(item) {
      this.$router.push({
        path: "/jpcol/tiaoli/tiaolidetail",
        query: {
          tlId: item.id,
        },
      });
    },
    subsearch() {
      let data = {
        ...this.seaobj,
      };
      this.$store.commit("jpcol/uptlsea", data);
      this.$router.push({
        path: "/jpcol/tiaoli/tiaoliifyul?search=1",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.jpcolbanner {
  width: 1200px;
  padding: 40px 0;
  margin: 0 auto;
  .flswip {
    width: 539px;
    height: 350px;
    border-right: 1px solid #e8e8e8;
    background-color: #fff;
    .fd {
      width: 360px;
      margin: 0 auto;
      padding-top: 74px;
      .bt {
        font-size: 30px;
        color: #333333;
      }
      .nr {
        margin-top: 16px;
        font-size: 14px;
        color: #999999;
        line-height: 27px;
      }
    }
    ::v-deep .is-active .el-carousel__button {
      border: none;
      background: #ff8a22;
    }
    ::v-deep .el-carousel__button {
      width: 15px;
      height: 15px;
      border: 1px solid #999;
      border-radius: 50%;
    }
    ::v-deep .el-carousel__indicators--horizontal {
      bottom: 20px;
    }
  }
  .tmfrom {
    width: 660px;
    height: 350px;
    background-color: #fff;
    padding: 46px 70px;
    .from {
      .inp {
        width: 250px;
        height: 40px;
        padding-left: 10px;
        padding-bottom: 1px;
        margin-bottom: 25px;
        font-size: 14px;
        color: #333333;
        border: 1px solid #cecece;

        ::v-deep .el-input__inner {
          border: none;
          height: 36px;
        }

        ::v-deep .el-select-dropdown__wrap {
          max-height: 200px;
        }
        ::v-deep .el-input__icon {
          display: none;
        }
        > div {
          height: 40px;
          line-height: 40px;
        }
        .text {
          flex: 1;
          input {
            width: 100%;
            height: 36px;
            border: none;
            outline: none;
          }
        }
        .sele1 {
          width: 160px;
        }
      }
      .inp2 {
        width: 250px;
        ::v-deep .el-input--prefix .el-input__inner {
          padding-right: 10px;
        }
        .itm {
          width: 115px;
          margin-bottom: 25px;
        }
      }
    }
    .search {
      cursor: pointer;
      margin: 25px auto 0;
      width: 160px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      background: #3e8fff;
      border-radius: 20px;
      font-size: 16px;
      color: #ffffff;
    }
    .mar20 {
      margin-right: 20px;
    }
  }
}
</style>